<template>
  <footer id="footer" class="footer" style="position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 0; padding-top: 0rem !important;
    padding-bottom: 1rem !important;">
    <div class="container">
      <div class="row">
        <div id="div" class="mb-4 text-center col-lg-12" style="display: flex;
          justify-content: center;
          gap: 15px;">
          <a
            href="https://www.humantrends.es/"
            target="_blank"
            class="mb-2 text-secondary mb-sm-0 text-white "
          >
            Human Trends
          </a>
          <a
            href="https://www.humantrends.es/emailai-privacy-policy"
            target="_blank"
            class="mb-2 text-secondary mb-sm-0 text-white "
          >
            Privacy policy
          </a>
          <!--<a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            About Us
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Team
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Products
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Blog
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Pricing
          </a>
        </div>
        <div class="mx-auto mt-2 mb-4 text-center col-lg-8">
          <a
            href="javascript:;"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-dribbble"></span>
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-twitter"></span>
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-instagram"></span>
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-pinterest"></span>
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-github"></span>
          </a>-->
        </div>
      </div>
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8">
          <p class="mb-0 text-secondary text-white ">
            Copyright © {{ new Date().getFullYear() }} Tomate by Human Trends.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer-entrada"
};
</script>

<style scoped>
  @media (max-width: 490px) {
    #div {
      margin: 0 !important;
    }

    #footer {
      position: relative !important;
      
    }
  }
</style>
